import { Newspaper, Mail, ExternalLink } from "lucide-react";
import { useCompanyContact } from "../lib/companyContact";

export default function PrensaPage() {
  const { contact } = useCompanyContact();
  const PRESS_EMAIL = contact.press_email;
  return (
    <div className="min-h-screen bg-sand pb-16" data-testid="prensa-page">
      <div className="container-main py-10 max-w-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-violet-500/10 text-violet-600 flex items-center justify-center">
            <Newspaper className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-3xl font-heading font-bold text-agave">Prensa</h1>
            <p className="text-sm text-neutral-600">Medios, entrevistas y colaboraciones oficiales.</p>
          </div>
        </div>

        <div className="card-base">
          <p className="text-neutral-700 leading-relaxed mb-6">
            Para solicitudes de prensa, entrevistas, medios, colaboraciones o información oficial de RivoNes,
            por favor contáctanos por correo electrónico.
          </p>

          <a
            href={`mailto:${PRESS_EMAIL}`}
            className="inline-flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white font-medium px-5 py-2.5 rounded-xl transition-colors"
            data-testid="prensa-email-cta"
          >
            <Mail className="w-5 h-5" />
            Contactar Prensa
            <ExternalLink className="w-3.5 h-3.5 opacity-70" />
          </a>

          <p className="text-xs text-neutral-500 mt-4">
            También puedes escribir directamente a{" "}
            <a href={`mailto:${PRESS_EMAIL}`} className="text-violet-600 font-medium underline">
              {PRESS_EMAIL}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
